import React, { useEffect, useState } from "react";
import { Form, Button, Steps, Spin, message } from "antd";
import Title from "antd/es/typography/Title";
import { AdvertFormFirstPage } from "./Components/AdvertFormFirstPage";
import AdvertFormSecondPage from "./Components/AdvertFormSecondPage";
import dayjs from "dayjs";
import useFirmService from "../../../services/useFirmService";
import { useLocation, useNavigate } from "react-router-dom";

const { Step } = Steps;

const CopyAdvert = () => {
  const { state } = useLocation();
  const { advertId } = state || {};

  const [current, setCurrent] = useState(0);
  const [form] = Form.useForm();
  const navigate = useNavigate();
  //FIRST PAGE STATE VARIABLES
  const [durationType, setDurationType] = useState(null);
  const [jobType, setJobType] = useState(null);
  const [isRangedWage, setIsRangedWage] = useState(false);
  const [startDate, setStartDate] = useState(null);

  //SECOND PAGE STATE VARIABLES
  const [isAbroad, setIsAbroad] = useState(false);
  const [selectedCityId, setSelectedCityId] = useState(null);
  const [isExperienced, setIsExperienced] = useState(false);
  const [isUseSavedLocation, setIsUseSavedLocation] = useState(false);
  const [saveLocation, setSaveLocation] = useState(false);

  const { useAddAdvert, useGetFirmAdvertById } = useFirmService();
  const { mutate: addAdvert, isPending: isAddAdvertLoading } = useAddAdvert();

  if (advertId === undefined) {
    message.info("Bir hata oluştu, Lütfen Tekrar Deneyiniz");
  }

  const { data: advertDetails, isLoading: isGetAdvertLoading } =
    useGetFirmAdvertById(advertId);
  const onFinish = () => {
    const values = form.getFieldsValue(true);
    const location = values.location;

    console.log("Form values:", values);
    const requestBody = {
      title: values.title,
      jobDescription: values.jobDescription,
      requiredQualification: values.requiredQualification,
      personnelCount: values.personnelCount,
      jobType: values.jobType,
      durationType: values.durationType,
      jobDuration: values.jobDuration,
      wagePeriod: values.wagePeriod,
      wageType: values.wageType,
      currency: "TRY",
      advertStartDate: dayjs(values.advertStartEndDate[0]).format("YYYY-MM-DD"),
      advertEndDate: dayjs(values.advertStartEndDate[1]).format("YYYY-MM-DD"),
      displayOrder: 0, //
      minAge: values.minAge,
      maxAge: values.maxAge,
      sectorId: values.sectorId,
      positionId: values.positionId,
      departmentId: values.departmentId,
      minEducationLevel: values.minEducationLevel,
      optionIds: values.optionIds?.flat().filter((id) => id != null) || [],
      keywords: values.keywords,
      // address: "Paşa Mahallesi Gönül Sokak, 16/6 Şişli İstanbul",
      // latitude: 41.015137,
      // longitude: 28.97953,
      // saveLocation: false,
      ...(isUseSavedLocation
        ? { savedLocationId: values.savedLocationId, saveLocation: false }
        : {
            address: location.address,
            latitude: location.latitude,
            longitude: location.longitude,
            ...(isAbroad
              ? { countryId: values.countryId }
              : values.district
              ? { districtId: values.district }
              : { cityId: values.city }),
            saveLocation: saveLocation,
          }),
      isExperienceRequired: isExperienced,
      ...(isExperienced ? { experienceYear: values.experienceYear } : {}),
      ...(jobType !== "LONG_TERM" && {
        startDate: dayjs(values.jobInterval[0]).format("YYYY-MM-DD"),
        endDate: dayjs(values.jobInterval[1]).format("YYYY-MM-DD"),
      }),

      ...(!isRangedWage
        ? { wage: values.wage }
        : { minWage: values.minWage, maxWage: values.maxWage }),

      // ...(isAbroad
      //   ? { countryId: values.countryId }
      //   : values.district
      //   ? { districtId: values.district }
      //   : { cityId: values.city }),
      status: 1,
    };
    addAdvert(requestBody);
    console.log("requestBody is", requestBody);
  };

  const next = () => {
    form
      .validateFields()
      .then(() => {
        // Proceed to the next step only if validation passes
        setCurrent(current + 1);
      })
      .catch((errorInfo) => {
        // Handle validation errors here, or simply do nothing
        console.log("Validation failed:", errorInfo);
      });
    // setCurrent(current + 1);
  };

  const prev = () => {
    setCurrent(current - 1);
  };

  const steps = [
    {
      title: "İlan Bilgileri",
      content: (
        <AdvertFormFirstPage
          form={form}
          durationType={durationType}
          isRangedWage={isRangedWage}
          jobType={jobType}
          setDurationType={setDurationType}
          setIsRangedWage={setIsRangedWage}
          setJobType={setJobType}
          setStartDate={setStartDate}
          startDate={startDate}
        />
      ),
    },
    {
      title: "Aday Bilgileri",
      content: (
        <AdvertFormSecondPage
          form={form}
          isAbroad={isAbroad}
          isExperienced={isExperienced}
          selectedCityId={selectedCityId}
          setIsAbroad={setIsAbroad}
          setIsExperienced={setIsExperienced}
          setSelectedCityId={setSelectedCityId}
          isUseSavedLocation={isUseSavedLocation}
          setIsUseSavedLocation={setIsUseSavedLocation}
          saveLocation={saveLocation}
          setSaveLocation={setSaveLocation}
        />
      ),
    },
  ];

  useEffect(() => {
    if (advertDetails?.data) {
      const details = advertDetails.data;

      // Set form values for first page
      form.setFieldsValue({
        title: details.title,
        sectorId: details.sector?.id,
        personnelCount: details.personnelCount,
        // advertStartEndDate:
        //   details.advertStartDate && details.advertEndDate
        //     ? [dayjs(details.advertStartDate), dayjs(details.advertEndDate)]
        //     : undefined,
        keywords: details.keywords,
        jobType: details.jobType?.name,
        durationType: details.durationType?.name,
        jobDuration: details.jobDuration,
        jobInterval:
          details.startDate && details.endDate
            ? [dayjs(details.startDate), dayjs(details.endDate)]
            : undefined,
        jobDescription: details.jobDescription,
        requiredQualification: details.requiredQualification,
        wageType: details.wageType?.name,
        wagePeriod: details.wagePeriod?.name,
        wage: details.wage,
        minWage: details.minWage,
        maxWage: details.maxWage,
        experienceYear: details.experienceYear,

        // Second page fields
        departmentId: details.department?.id,
        positionId: details.position?.id,
        optionIds: details.options?.map((option) =>
          option.options.filter((opt) => opt.isSelected).map((opt) => opt.id)
        ),
        city: details.district?.city?.id,
        district: details.district?.id,
        countryId: details.country?.id,
        minEducationLevel: details.minEducationLevel?.name,
        minAge: details.minAge,
        maxAge: details.maxAge,
        location: {
          latitude: details.coordinate?.latitude,
          longitude: details.coordinate?.longitude,
          address: details.address,
        },
      });

      // Set state values
      if (details.wage === null) {
        setIsRangedWage(true);
      }

      if (details.country && !details.city) {
        setIsAbroad(true);
      }

      if (details.district?.city?.id) {
        setSelectedCityId(details.district.city.id);
      }

      if (details.isExperienceRequired) {
        setIsExperienced(true);
      }

      if (details.advertStartDate) {
        setStartDate(dayjs(details.advertStartDate));
      }

      if (details.jobType?.name) {
        setJobType(details.jobType.name);
      }

      if (details.durationType?.name) {
        setDurationType(details.durationType.name);
      }
    }
  }, [advertDetails]);

  const isLoading = isAddAdvertLoading || isGetAdvertLoading;
  if (isLoading) {
    return (
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100vh",
        }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <Spin spinning={isAddAdvertLoading}>
      <Form form={form} onFinish={onFinish} layout="vertical">
        <Title
          style={{ textAlign: "center", marginBottom: 15, marginTop: 0 }}
          level={3}>
          Yeni İş İlanı Oluştur
        </Title>
        <Steps current={current}>
          {steps.map((item) => (
            <Step key={item.title} title={item.title} />
          ))}
        </Steps>
        <div style={{ marginTop: 24 }}>{steps[current].content}</div>
        <div style={{ marginTop: 24 }}>
          {current < steps.length - 1 && (
            <Button type="primary" onClick={next}>
              Sonraki Sayfa
            </Button>
          )}
          {current === steps.length - 1 && (
            <Button type="primary" htmlType="submit">
              İlanı Oluştur
            </Button>
          )}
          {current > 0 && (
            <Button style={{ margin: "0 8px" }} onClick={prev}>
              Önceki
            </Button>
          )}
        </div>
      </Form>
    </Spin>
  );
};

export default CopyAdvert;
